/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Street_Address_PlaceholderInputs */

const en_orders_street_address_placeholder = /** @type {(inputs: Orders_Street_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Street address`)
};

const es_orders_street_address_placeholder = /** @type {(inputs: Orders_Street_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Direccion`)
};

/**
* | output |
* | --- |
* | "Street address" |
*
* @param {Orders_Street_Address_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_street_address_placeholder = /** @type {((inputs?: Orders_Street_Address_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Street_Address_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_street_address_placeholder(inputs)
	return es_orders_street_address_placeholder(inputs)
});